<script>
  import DadosPessoais from './DadosPessoais'
  import DadosMatricula from './DadosMatricula'
  import Contrato from './Contrato'
  import Financeiro from './Financeiro'
  import Confirmacao from './Confirmacao'
  import Pagamento from './Pagamento'

  import helpers from '@mixins/helper'

  import bus from '@utils/bus'

  import * as restfulService from '../../../services/restfulService'

  export default {
    mixins: [helpers],
    components: {DadosPessoais, DadosMatricula, Contrato, Financeiro, Confirmacao, Pagamento},
    name: 'dashboard-matricula-online',
    data () {
      return {
        mostrarModal: false,
        textoJanela: 'Atualize seus dados:',
        etapaAtiva: 1,
        desabilita: {
          aba1: false,
          aba2: true,
          aba3: true,
          aba4: true,
          aba5: true,
          aba6: true
        },
        dados: {
          matricula: {
            ref_contrato: '',
            ref_curriculo: '',
            ref_disciplina_cpp: '',
            ref_area_tematica: '',
            modulo: '',
            descricao: '',
            aceito_termos: false,
            ciente_nao_trocar_cpp: false,
            intencaoVaga: {},
            incentivos: [],
            parcelamento: '',
            contrato: {
              descricao: '',
              disciplinas: [],
              cpp: {}
            },
            parcelas: {},
            titulo: {}
          },
          pessoa: {
            nome: '',
            email: '',
            cep: '',
            rua: '',
            numero: '',
            bairro: '',
            ref_cidade: ''
          },
          pessoa_fisica: {
            dt_nascimento: '',
            fone_celular: '',
            cpf: ''
          }
        }
      }
    },
    mounted () {
      bus.$on('fecharJanelaMatricula', () => {
        this.mostrarModal = false
      })
      bus.$on('abrirJanelaMatricula', () => {
        this.mostrarModal = true
      })
    },
    computed: {
      isMobileSize () {
        return this.isMobile().any()
      }
    },
    methods: {
      exibePopUpMatriculaOnline () {
        restfulService.get('matricula-online')
          .then(response => {
            if (!response.error) {
              this.mostrarModal = true
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      fecharJanela () {
        bus.$emit('fecharJanelaMatricula')
      }
    }
  }
</script>

<template>
    <v-dialog v-model="mostrarModal"
              persistent
              scrollable
              :fullscreen="$vuetify.breakpoint.xsOnly"
              :width="isMobileSize ? '98%' : '70%'">
        <v-card>
            <v-card-title class="primary white--text">
              <h2>{{textoJanela}}</h2>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="fecharJanela">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 95vh;">
                <v-form>

                  <v-stepper v-model="etapaAtiva">

                    <v-stepper-header>
                      <v-stepper-step :complete="etapaAtiva > 1" step="1">Dados Pessoais</v-stepper-step>

                      <v-divider></v-divider>

                      <v-stepper-step :complete="etapaAtiva > 2" step="2">Dados da Matrícula</v-stepper-step>

                      <v-divider></v-divider>

                      <v-stepper-step :complete="etapaAtiva > 3" step="3">Contrato</v-stepper-step>
                      <v-divider></v-divider>

                      <v-stepper-step :complete="etapaAtiva > 4" step="4">Financeiro</v-stepper-step>
                      <v-divider></v-divider>

                      <v-stepper-step :complete="etapaAtiva > 5" step="5">Confirmação</v-stepper-step>
                      <v-divider></v-divider>

                      <v-stepper-step step="6">Pagamento</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content step="1">
                        <dados-pessoais :dados="dados"
                                            :etapa-ativa.sync="etapaAtiva"
                                            :desabilita.sync="desabilita"/>
                      </v-stepper-content>

                      <v-stepper-content step="2">
                        <dados-matricula :dados="dados"
                                          :etapa-ativa.sync="etapaAtiva"
                                          :desabilita.sync="desabilita"
                                          :texto-janela.sync="textoJanela"/>
                      </v-stepper-content>

                      <v-stepper-content step="3">
                        <contrato :dados="dados"
                                      :etapa-ativa.sync="etapaAtiva"
                                      :desabilita.sync="desabilita"/>

                      </v-stepper-content>

                      <v-stepper-content step="4">
                        <financeiro :dados="dados"
                                        :etapa-ativa.sync="etapaAtiva"
                                        :desabilita.sync="desabilita"/>

                      </v-stepper-content>
                      <v-stepper-content step="5">
                        <confirmacao :dados="dados"
                                         :etapa-ativa.sync="etapaAtiva"
                                         :desabilita.sync="desabilita"
                                         :mostrar-modal.sync="mostrarModal"/>

                      </v-stepper-content>
                      <v-stepper-content step="6">
                        <pagamento :dados="dados"
                                       :etapa-ativa.sync="etapaAtiva"
                                       :desabilita.sync="desabilita"
                                       :mostrar-modal.sync="mostrarModal"/>
                      </v-stepper-content>

                    </v-stepper-items>
                  </v-stepper>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped lang="scss">
@media all and (max-width: 800px) {
  .v-card__text {
    padding:5px;
  }
  .v-stepper__content{
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?11c7d7b8